import { Link } from '@chegg-ui/link'
import { Config } from '@chegg-wt/core/config'
import { BibliographyUpsellCopy } from '@chegg-wt/core/types/features'
import { BibliographyB1Copy } from '@chegg-wt/core/types/copy'

export const upsellCopy: BibliographyUpsellCopy = {
  plagiarism: {
    UPSELL_HEADING: 'Writing help from start to finish',
    CTA_COPY: 'Try EasyBib Plus*',
    FEATURE_LIST: [
      'Unlimited plagiarism & grammar checks',
      'Summarized feedback from writing experts',
      '7,000+ styles including APA & Chicago',
    ],
    IMAGE_ALT_TEXT: 'plagiarism detected paper',
  },
  expertProofRead: {
    UPSELL_HEADING: 'Expert proofreading for papers',
    CTA_COPY: 'Try Expert Check',
    FEATURE_LIST: [
      'Get personalized comments on your main idea, conclusion & more',
      'Detailed feedback returned within 24 hours',
      '3-day free trial*',
    ],
    IMAGE_ALT_TEXT: 'plagiarism detected paper',
  },
}

export const bibliographyB1: BibliographyB1Copy = {
  title: 'Want to Learn More?',
  contents: [
    {
      header: 'Citation Guides',
      body: () => (
        <div>
          Learn how to clearly cite with our&nbsp;
          <Link href={`${Config.baseUrl}/guides/?from=nav`}>citation guides</Link>
          &nbsp;on MLA, APA, and Chicago citation styles. See the basics of each style, as
          well as real examples for you to learn from.
        </div>
      ),
    },
    {
      header: 'Writing Guides',
      body: () => (
        <div>
          Find breakdowns on the different steps of the&nbsp;
          <Link href={`${Config.baseUrl}/guides/students/`}>writing process</Link>. With
          tips on brainstorming to structuring arguments to revising, you’ll learn how to
          make a killer paper.
        </div>
      ),
    },
    {
      header: 'Add Annotations',
      body: () => (
        <div>
          Every citation form has a spot for you to include an annotation. Go to the
          citation form and look at the bottom of the page under “More options.”
          Don&apos;t know what to write? Start by reading&nbsp;
          <Link href={`${Config.baseUrl}/guides/annotated-bibliographies/`}>
            this guide
          </Link>
          .
        </div>
      ),
    },
    {
      header: 'Evaluate Your Sources',
      body: () => (
        <div>
          Citations won&apos;t save your grade if your sources are untrustworthy. Always
          take a moment to consider the credibility of what you are citing.
          <Link
            href={`${Config.baseUrl}/guides/how-to-make-sure-your-sources-are-legit/`}
          >
            Here are guides
          </Link>
          &nbsp;to help.
        </div>
      ),
    },
    {
      header: 'Finish With a Title Page',
      body: () => (
        <div>
          Every good paper needs a title page. Don’t know how to create one? No problem!
          We have a quick&nbsp;
          <Link href="http://titlepage.easybib.com/?utm_source=easybib&utm_medium=navigation&utm_campaign=product">
            Title Page creator
          </Link>
          &nbsp;for you.
        </div>
      ),
    },
    {
      header: 'Easy In-text Citations',
      body: () => (
        <div>
          Under every citation is a link to our in-text citation tools. Simply click
          &quot;parenthetical&quot; or &quot;footnote&quot; to bring up the feature and
          begin creating in-text citations!
        </div>
      ),
    },
    {
      header: 'Select the Source Type',
      body: () => (
        <div>
          Cite correctly from the beginning! Look at our list of 50+ source types, choose
          what best describes your source, and fill out the citation form. It’s that
          simple.
        </div>
      ),
    },
    {
      header: 'Find Your Citation Style',
      body: (children) => (
        <div>
          We always have MLA, but APA, Chicago/Turabian and over 7,000 additional
          citations styles are available with an EasyBib Plus subscription. Learn&nbsp;
          {children}
        </div>
      ),
    },
    {
      header: 'Blog Spot',
      body: () => (
        <div>
          <Link href={`${Config.baseUrl}/guides/blog/`}>Our blog</Link>
          &nbsp;is the place to be for tips on how to be a better writer, citing fun
          sources, and info on the latest updates. Check it out today!
        </div>
      ),
    },
    {
      header: 'Get Extra Support',
      body: () => (
        <div>
          Visit our&nbsp;
          <Link href="https://www.chegg.com/contactus/easybibsupport/?Website=External">
            EasyBib Support Center
          </Link>
          &nbsp;for help getting started, answers to registration questions, and general
          account information.
        </div>
      ),
    },
  ],
}
